export enum MeetingChoice {
	SCHEDULE = "schedule",
	LOG = "log"
}

export enum TimePickerType {
	Hour = "Hour",
	Minute = "Minute",
	Second = "Second"
}
